import { MobileShell } from '@/components/dashboard/DashboardShell';
import { AttendanceContent } from '@/components/dashboard/AttendanceContent';

export default function AttendanceMobile() {
  return <AttendanceContent Shell={MobileShell} />;
}
